<template>
  <div>
    <p>
      {{ formattedTiming }}
    </p>
    <p>
      {{ formatDuration }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'TableCellTiming',
  props: {
    payload: Object
  },
  data () {
    return {
      timing: this.payload.timing
    }
  },
  computed: {
    formattedTiming () {
      return this.$moment(new Date(this.timing)).calendar()
    },
    formatDuration () {
      const status = this.payload.status
      if (status == 'done') {
        return `Duration: ${this.payload.duration} minutes`
      }
      if (status == 'in_progress') {
        return `Duration: ${this.$moment(new Date()).diff(new Date(this.payload.updated_at), 'minutes').toString().padStart(3, '0')} minutes`
      }
      return ''
    }
  }
}
</script>
